export default __webpack_public_path__ + "static/media/playtime.ca7ed624.png";